import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconSteeringWheel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSteeringWheel"><Circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 1.5V22.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.57422 4.5752L19.4235 19.4244" stroke="currentColor" strokeLinecap="square"/><Path d="M1.5 12H22.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.57422 19.4244L19.4235 4.5752" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSteeringWheel;
